import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router } from '@angular/router'
import { Observable } from 'rxjs'

import { environment } from '../../../environments/environment'
import { FlashMessageService } from '../services/flash-message.service'

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(
    private router: Router,
    private flashMessageService: FlashMessageService
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (localStorage.getItem(environment.tokenName)) {
      return true
    }

    this.router.navigate(['/login'], {
      queryParams:
        next.url && next.url.length ? { redirectTo: next.url[0].path } : {}
    })

    this.flashMessageService.info(
      `Veuillez vous connecter pour accéder à l'application.`
    )
    return false
  }
}
